var render = function render(){var _vm=this,_c=_vm._self._c;return _c('List',{attrs:{"title":_vm.title,"data":_vm.data,"noDataText":_vm.noDataText,"hasNext":_vm.hasNext,"hasPrev":_vm.hasPrev,"displayAll":true},on:{"fetchList":_vm.getAccounts}})
}
var staticRenderFns = []

export { render, staticRenderFns }